import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApi } from "../utils/Api";
import { useCart } from "../context/CartContext";

export default function OrderSuccessRedirect() {
  const { apiFetch } = useApi();
  const { clearCart } = useCart();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("t");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("Finalizing your order…");

  useEffect(() => {
    if (!token) {
      setError("Missing token");
      return;
    }

    let cancelled = false;

    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    (async () => {
      try {
        // try for ~30 seconds
        for (let i = 0; i < 15; i++) {
          if (cancelled) return;

          const res = await apiFetch("get-encrypted-order-id", {
            success_token: token,
          });

          if (res?.success && res?.encrypted_order_id) {
            clearCart();
            navigate(
              `/order-tracking?id=${encodeURIComponent(res.encrypted_order_id)}`,
              { replace: true },
            );
            return;
          }

          const msg = String(res?.message || "").toLowerCase();

          // ✅ pending = keep waiting
          if (msg === "pending") {
            setMessage("Payment not confirmed yet… waiting.");
            await sleep(2000);
            continue;
          }

          // ❌ real errors
          setError(res?.message || "Could not finalize order.");
          return;
        }

        setError("Payment is still processing. If you paid, please refresh in a moment.");
      } catch (e) {
        setError("Server error. Please refresh.");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, apiFetch, navigate, clearCart]);

  if (error) return <div style={{ padding: 20 }}>Error: {error}</div>;
  return <div style={{ padding: 20 }}>{message}</div>;
} 
